export default "__VITE_ASSET__e2af1d65__"